// extracted by mini-css-extract-plugin
export var button = "_a5-4";
export var hasDarkBackground = "_a5-7";
export var hasLightBackground = "_a5-6";
export var iconWrapper = "_a5-0";
export var large = "_a5-2";
export var medium = "_a5-1";
export var small = "_a5-5";
export var xsmall = "_a5-3";